import React from 'react';

interface LogoProps {
  size?: number;
  color?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 32, color = 'white' }) => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: `${size}px`,
      fontWeight: 'bold',
      color: color,
    }}>
      {/* Logo image */}
      <img 
        src="/raedar_logo.png" 
        alt="rAEdar Logo"
        style={{
          width: `${size}px`,
          height: `${size}px`,
          objectFit: 'contain',
          filter: color === 'white' ? 'brightness(0) invert(1) drop-shadow(0 2px 4px rgba(0,0,0,0.3))' : 'none',
          transition: 'all 0.2s ease',
        }}
      />
    </div>
  );
};

export default Logo;
